import { html, nothing, render } from "lit-html";
import connect from "../../../shared/data-store/connect";
import { store } from "./DataStore";

import "./PriceFilter";
import "./CancelationFilter";
import "../PriceFilterInfoWithoutDates";
import { FilterWithInitialLoadingStyle } from "../FilterWithInitialLoadingStyle";
import { travelData } from "@escapio/portal/state/travelData";

customElements.define(
	"esc-hotel-list-price-filter-section",
	class extends connect(FilterWithInitialLoadingStyle, store) {
		update(_, { priceFiltersVisible }) {
			if (priceFiltersVisible) {
				this.classList.remove("price-filter__container--info-shown");
			} else {
				this.classList.add("price-filter__container--info-shown");
			}
			this.style.display =
				priceFiltersVisible || !travelData.hasDates ? "" : "none";
			render(
				priceFiltersVisible
					? html`<esc-hotel-list-price-filter
								class="price-filter"
								track-label-suffix=${this.trackLabelSuffix}
							></esc-hotel-list-price-filter>
							<esc-hotel-list-cancelation-filter
								track-label-suffix=${this.trackLabelSuffix}
							></esc-hotel-list-cancelation-filter>`
					: travelData.hasDates
						? nothing
						: html`<esc-price-filter-info-without-dates
								event-category="Filter"
							></esc-price-filter-info-without-dates>`,
				this,
			);

			// remove min-height after rendering component
			this.removeInitialLoading();
		}

		get trackLabelSuffix() {
			return this.getAttribute("track-label-suffix") || "";
		}
	},
);
